import { put, call, all, takeLatest, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneInspection,
  GET_ONE_INSPECTION,
  GET_ONE_INSPECTION_ERROR,
  GET_ONE_INSPECTION_SUCCESS,
} from '../types/inspection/get-one'

import {
  GetAllInspections,
  GET_ALL_INSPECTIONS,
  GET_ALL_INSPECTIONS_ERROR,
  GET_ALL_INSPECTIONS_SUCCESS,
} from '../types/inspection/get-all'

import {
  NewInspection,
  NEW_INSPECTION,
  NEW_INSPECTION_ERROR,
  NEW_INSPECTION_SUCCESS,
} from '../types/inspection/new'

import {
  EditInspection,
  EDIT_INSPECTION,
  EDIT_INSPECTION_ERROR,
  EDIT_INSPECTION_SUCCESS,
} from '../types/inspection/edit'

import {
  DeleteInspection,
  DELETE_INSPECTION,
  DELETE_INSPECTION_ERROR,
  DELETE_INSPECTION_SUCCESS,
} from '../types/inspection/delete'

import {
  GetInspectionsMetrics,
  GET_INSPECTIONS_METRICS,
  GET_INSPECTIONS_METRICS_ERROR,
  GET_INSPECTIONS_METRICS_SUCCESS,
} from '../types/inspection/get-metrics'

import {
  GET_LAST_INSPECTION,
  GET_LAST_INSPECTION_ERROR,
  GET_LAST_INSPECTION_SUCCESS,
} from '../types/inspection/get-last'


import downloadEmptyInspection from '../../services/inspection';
import {
  DOWNLOAD_PDF_ERROR,
  DOWNLOAD_PDF_SUCCESS,
  DOWNLOAD_PDF,
  DownloadPdf
} from '../types/inspection/download-pdf';

import downloadfullinspection from '../../services/inspection'

import {
  DOWNLOAD_FULL_INSPECTION,
  DOWNLOAD_FULL_INSPECTION_SUCCESS,
  DOWNLOAD_FULL_INSPECTION_ERROR,
  DownloadFullInspection
} from '../types/inspection/download-full-inspection';


const currentAllInspectionsStore = ({ inspectionStore }) => inspectionStore.all.data

function* getOneInspection({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.getOne, payload)

    if (error) {
      yield put({
        type: GET_ONE_INSPECTION_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_INSPECTION_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_INSPECTION_ERROR,
      payload: 'Error al obtener una inspección',
    })
  }
}

function* getAllInspections({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_INSPECTIONS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_ALL_INSPECTIONS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_INSPECTIONS_ERROR,
      payload: 'Error al obtener todas las inspecciones',
    })
  }
}

function* newInspection({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.new, payload)

    if (error) {
      yield put({
        type: NEW_INSPECTION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const newInspection = response
      const currentAllInspections = yield select(currentAllInspectionsStore);

      // Iterar sobre cada grupo en allInspections
      for (const group of currentAllInspections) {
        // Iterar sobre los resultados dentro del grupo
        for (const result of group.results) {
          // Verificar si el cliente coincide
          if (result.customer._id === response?.customer?._id) {
            // Agregar la nueva inspección a la lista de inspecciones del cliente
            result.inspections.push(newInspection);
          }
        }
      }

      yield all([
        put({
          type: NEW_INSPECTION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_INSPECTIONS_SUCCESS,
          payload: currentAllInspections,
        }),
      ])
    }
  } catch {
    yield put({
      type: NEW_INSPECTION_ERROR,
      payload: 'Error al crear una nueva inspección',
    })
  }
}

function* editInspection({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.edit, payload)
    if (error) {
      yield put({
        type: EDIT_INSPECTION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield all([
        put({
          type: EDIT_INSPECTION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_INSPECTION_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_INSPECTION_ERROR,
      payload: 'Error al editar una inspección',
    })
  }
}

function* deleteInspection({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_INSPECTION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllInspections = yield select(currentAllInspectionsStore);

      for (const group of currentAllInspections) {
        // Iterar sobre los resultados dentro del grupo
        for (const result of group.results) {
          // Buscar y eliminar la inspección del cliente
          result.inspections = result.inspections.filter(
            (inspection) => {
              return inspection._id !== payload?.idInspection
            }
          );
        }
      }

      yield all([
        put({
          type: DELETE_INSPECTION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_INSPECTIONS_SUCCESS,
          payload: currentAllInspections,
        }),
      ])
    }
  } catch {
    yield put({
      type: DELETE_INSPECTION_ERROR,
      payload: 'Error al eliminar una inspección',
    })
  }
}

function* getMetrics({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.getMetrics, payload)
    if (error) {
      yield put({
        type: GET_INSPECTIONS_METRICS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_INSPECTIONS_METRICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_INSPECTIONS_METRICS_ERROR,
      payload: 'Error al obtener métricas de las inspecciones',
    })
  }
}

function* getLastInspection({ payload }) {
  console.log("SAGA getLastInspection", payload)
  try {
    const { response, error } = yield call(services.periodicCheck.getLast, payload)
    if (error) {
      yield put({
        type: GET_LAST_INSPECTION_ERROR,
        payload: error
      })
    } else {
      yield put({
        type: GET_LAST_INSPECTION_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_LAST_INSPECTION_ERROR,
      payload: 'Error al obtener una la última inspección',
    })
  }
}

function* downloadInspectionPdfSaga({ payload }: DownloadPdf) {
  try {
    const { response, error } = yield call(
      downloadEmptyInspection.downloadEmptyInspection,
      payload
    );
    if (response instanceof Blob && response.type !== 'text/html' && response.size > 0) {
      const url = window.URL.createObjectURL(response)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'inspection_template.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)


      yield put({
        type: DOWNLOAD_PDF_SUCCESS,
      })
    } else {
      console.error("Respuesta inválida del servidor:", response);
      yield put({ type: DOWNLOAD_PDF_ERROR, payload: 'El servidor no devolvió un PDF válido' });
    }
  }
  catch {
    yield put({
      type: DOWNLOAD_PDF_ERROR, payload: 'Error downloading PDF'
    });
  }
}

function* downloadFullInspectionPdfSaga({ payload }: DownloadFullInspection) {
  console.log('SAGA FULL INSPECTION payload', payload)
  console.log('🔥 SAGA FULL INSPECTION EJECUTADA', payload);
  try {
    const { response, error, headers } = yield call(
      downloadfullinspection.downloadfullinspection,
      payload
    );
    if (response instanceof Blob && response.type !== 'text/html' && response.size > 0) {
      // Extraer nombre del archivo del header Content-Disposition
      let filename = 'inspeccion.pdf'; // Nombre por defecto
      if (headers && headers['content-disposition']) {
        const contentDisposition = headers['content-disposition'];
        const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].trim().replace(/['"]/g, '');
        }
      }
      
      const url = window.URL.createObjectURL(response)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      yield put({
        type: DOWNLOAD_FULL_INSPECTION_SUCCESS,
      })
    } else {
      console.error("Respuesta inválida del servidor:", response);
      yield put({ type: DOWNLOAD_FULL_INSPECTION_ERROR, payload: 'El servidor no devolvió un PDF - Full Inspection - válido' });
    }
  } catch (e) {
    console.error('Error descargando PDF Full Inspection', e)
    yield put({
      type: DOWNLOAD_FULL_INSPECTION_ERROR,
      payload: 'Error interno al generar el PDF'
    })
  }
}


/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneInspection>(GET_ONE_INSPECTION, getOneInspection)
  yield takeLatest<GetAllInspections>(GET_ALL_INSPECTIONS, getAllInspections)
  yield takeLatest<GetOneInspection>(GET_LAST_INSPECTION, getLastInspection)
  yield takeLatest<NewInspection>(NEW_INSPECTION, newInspection)
  yield takeLatest<EditInspection>(EDIT_INSPECTION, editInspection)
  yield takeLatest<DeleteInspection>(DELETE_INSPECTION, deleteInspection)
  yield takeLatest<GetInspectionsMetrics>(GET_INSPECTIONS_METRICS, getMetrics)
  yield takeLatest<DownloadPdf>(DOWNLOAD_PDF, downloadInspectionPdfSaga)
  yield takeLatest<DownloadFullInspection>(DOWNLOAD_FULL_INSPECTION, downloadFullInspectionPdfSaga)
}
